import React, { useContext, useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Registration from "./pages/Registration";
import LoginPage from "./pages/Login";
import OrderPage from "./pages/Orders";
import CataloguePage from "./pages/Catalogue";
import ProfilePage from "./pages/Profile";
import Header from "./components/Header/topHeader";
import { Context as AuthContext } from "./context/AuthContext";
import SignUpPage from "./pages/signUp";
import LandingPage from "./pages/LandingPage";
import SMSBroadcast from "./pages/SMS";
import Coupons from "./pages/Coupons";
import CustomerData from "./pages/CustomerData";
import LoginExtensionPage from "./pages/LoginExtension";
import CMS from "./pages/CMS";
import Dashboard from "./pages/Dashboard";
import MarginUpload from "./pages/MarginUpload";

const Main = () => {
  const { state, checkAuth } = useContext(AuthContext);

  useEffect(() => {
    checkAuth();
  }, []);


  return state.userData ? <AuthRoutes /> : <LoginRoutes />;
};
export default Main;

const LoginRoutes = () => {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/signUp" component={SignUpPage} />
      <Route path="/registration" component={Registration} />
      <Route path="/gopos-auth" component={LoginExtensionPage} />
      <Route exact path="*">
        <Redirect to="/login" />
      </Route>
      {/* <Route component={ProfilePage}>
                    {/* <Redirect to="/orders" /> */}
      {/* </Route> */}
    </Switch>
  );
};

const AuthRoutes = () => {
  const { state } = useContext(AuthContext);
  const role = state && state.roleObj;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWidth]);

  return (
    <React.Fragment>
      <div>{state.userData ? <Header /> : null}</div>
      <div
        style={{
          position: "relative",
          top: "60px",
          left: width < 960 ? 0 : "240px",
          width: width < 960 ? "100%" : "calc(100% - 240px)",
        }}
      >
        <Switch>
          <PrivateRoute path="/orders" component={OrderPage} />
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/inventory" component={CataloguePage} />
          <PrivateRoute path="/profile" component={ProfilePage} />
          <PrivateRoute
            path="/sms"
            component={role.woSeller ? SMSBroadcast : OrderPage}
          />
          <PrivateRoute path="/coupons" component={Coupons} />
          <PrivateRoute path="/customer-details" component={CustomerData} />
          <PrivateRoute path="/commission" component={CMS} />
          <PrivateRoute path="/margin-upload" component={MarginUpload} />
          <PrivateRoute path="/gopos-auth" component={LoginExtensionPage} />
          <Route path="*">
            <Redirect to="/dashboard" />
          </Route>
        </Switch>
      </div>
    </React.Fragment>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { state } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        state.userData ? <Component {...props} /> : <Redirect to={"/login"} />
      }
    />
  );
};
